import * as React from "react";

import "./comment-edit-modal.scss";

import {bindInput}     from "@Common/react/bind-input";
import {cs}            from "@Common/react/chain-services";
import {UseState}      from "@Common/react/use-state";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const CommentEditModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        width: 500,
        top: 100,

        header: {noBorder: true},
        next,
        rootNext,
    })],
    ["state", ({modal}, next) => UseState({initValue: modal.params.value, next})],
    ({state, modal}) => (
        <div {...{
            className: "comment-edit-modal-095",

            "xd-qa-type": "card",
            "xd-qa-name": "Comment Edit Modal",
        }}>
            <div className="header">
                <div {...{
                    className: "title",
                    "xd-qa-type": "label",
                    "xd-qa-name": "Comment Edit Modal",
                }}>
                    {modal.params.title}
                </div>

                {modal.params.description && (
                    <div {...{
                        className: "description",
                        "xd-qa-type": "text",
                        "xd-qa-name": "Edition Description",
                    }}>
                        {modal.params.description}
                    </div>
                )}
            </div>
            <div className="content">
                    <textarea {...{
                        ...bindInput(state),
                        placeholder: modal.params.defaultValue,
                        "xd-qa-type": "textarea",
                        "xd-qa-name": "Comment",
                    }}/>

                <div {...{
                    className: "count",
                    "xd-qa-type": "text",
                    "xd-qa-name": "Comment characters count",
                }}>
                    {state.value?.length??0}/500
                </div>
                {state.value?.length > 500 && (
                    <div {...{
                        className: "error",
                        "xd-qa-type": "text",
                        "xd-qa-name": "Error message - Exceeded maximum length",
                    }}>
                        {
                            "You've exceeded the recommended 500 characters. The font size may be reduced to fit all " +
                            "of your text. We recommend keeping your comment under 500 characters for optimal font sizing."
                        }
                    </div>
                )}
            </div>

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: modal.close,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Cancel",
                }}>
                    Cancel
                </button>
                <button {...{
                    className: "extra",
                    onClick: () => {
                        modal.params.onReset();
                        modal.close();
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Reset",
                }}>
                    Reset
                </button>
                <button {...{
                    className: "next",
                    onClick: () => {
                        modal.params.onChange(state.value);
                        modal.close();
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Save Changes",
                }}>
                    Save Changes
                </button>

            </div>
        </div>
    ),
);
